/**
 * Navigation 그룹 브릿지 메소드
 */

import { sendMessageToApp } from '@/lib/bridge'
import type { ActionRequest, ActionResponse } from '@/lib/bridge/types'

/**
 * close 호출
 */
export const close = async (): Promise<ActionResponse<'Navigation', 'close'>> => {
  return await sendMessageToApp({
    group: 'Navigation',
    action: 'close',
    data: null
  })
}

/**
 * fallbackToNativeList 호출
 */
export const fallbackToNativeList = async (): Promise<ActionResponse<'Navigation', 'fallbackToNativeList'>> => {
  return await sendMessageToApp({
    group: 'Navigation',
    action: 'fallbackToNativeList',
    data: null
  })
}

/**
 * openExternal 호출
 */
export const openExternal = async (
  params: ActionRequest<'Navigation', 'openExternal'>
): Promise<ActionResponse<'Navigation', 'openExternal'>> => {
  return await sendMessageToApp({
    group: 'Navigation',
    action: 'openExternal',
    data: params
  })
}

/**
 * openViewUrl 호출
 */
export const openViewUrl = async (
  params: ActionRequest<'Navigation', 'openViewUrl'>
): Promise<ActionResponse<'Navigation', 'openViewUrl'>> => {
  return await sendMessageToApp({
    group: 'Navigation',
    action: 'openViewUrl',
    data: params
  })
}

/**
 * openInAppBrowser 호출
 */
export const openInAppBrowser = async (
  params: ActionRequest<'Navigation', 'openInAppBrowser'>
): Promise<ActionResponse<'Navigation', 'openInAppBrowser'>> => {
  return await sendMessageToApp({
    group: 'Navigation',
    action: 'openInAppBrowser',
    data: params
  })
}
